import React, { useState, useEffect } from "react";
import {
  Container, Row, Col, Form, Button, Accordion, Table, Badge, Alert
} from "react-bootstrap";
import { FaPlus, FaPhone, FaTrash, FaEdit, FaCheck, FaTimes, FaArrowUp, FaArrowDown } from "react-icons/fa";
import axios from "axios";

const API_URL = "https://autonotify-api.mobilibrasil.com/api/escalation";
const token = "Bearer AC48311f6664bbc01c45e34a5e33abff8e";

const Escalation = () => {
  const [contacts, setContacts] = useState({});
  const [newName, setNewName] = useState("");
  const [newPhone, setNewPhone] = useState("");
  const [newSetor, setNewSetor] = useState("");
  const [newPeriodo, setNewPeriodo] = useState("");
  const [error, setError] = useState("");
  const [editMode, setEditMode] = useState(null);
  const [editData, setEditData] = useState({ name: "", phone: "" });
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = () => {
    setLoading(true);
    axios.get(API_URL, { headers: { Authorization: token } })
      .then(res => setContacts(res.data))
      .catch(() => setError("Erro ao buscar contatos."))
      .finally(() => setLoading(false));
  };
  

  const handleAddContact = () => {
    if (!newName || !newPhone || !newSetor || !newPeriodo) {
      setError("Todos os campos são obrigatórios.");
      return;
    }

    let formattedPhone = newPhone.replace(/\D/g, "");
    if (!formattedPhone.startsWith("55")) {
      formattedPhone = "55" + formattedPhone;
    }
    formattedPhone = "+" + formattedPhone;

    if (formattedPhone.length < 13 || formattedPhone.length > 14) {
      setError("Número de telefone inválido!");
      return;
    }

    axios.post(API_URL, {
      name: newName,
      phone: formattedPhone,
      setor: newSetor,
      periodo: newPeriodo
    }, { headers: { Authorization: token } })
      .then(() => {
        fetchContacts();
        setNewName(""); setNewPhone(""); setNewSetor(""); setNewPeriodo("");
        setError("");
      })
      .catch(() => setError("Erro ao adicionar contato."));
  };

  const handleDelete = (setor, periodo, name) => {
    if (!window.confirm(`Remover ${name}?`)) return;

    axios.delete(API_URL, {
      headers: { Authorization: token },
      data: { setor, periodo, name }
    })
      .then(() => fetchContacts())
      .catch(() => setError("Erro ao remover contato."));
  };

  const handleEdit = (setor, periodo, name, phone) => {
    setEditMode({ setor, periodo, old_name: name });
    setEditData({ name, phone });
  };

  const handleCancelEdit = () => {
    setEditMode(null);
    setEditData({ name: "", phone: "" });
  };

  const handleSaveEdit = () => {
    const { old_name, setor, periodo } = editMode;
    let formattedPhone = editData.phone.replace(/\D/g, "");
    if (!formattedPhone.startsWith("55")) {
      formattedPhone = "55" + formattedPhone;
    }
    formattedPhone = "+" + formattedPhone;

    if (formattedPhone.length < 13 || formattedPhone.length > 14) {
      setError("Número de telefone inválido!");
      return;
    }

    axios.put(API_URL, {
      old_name,
      name: editData.name,
      phone: formattedPhone,
      setor,
      periodo
    }, { headers: { Authorization: token } })
      .then(() => {
        fetchContacts();
        handleCancelEdit();
      })
      .catch(() => setError("Erro ao editar contato."));
  };

  const moveContact = (setor, periodo, index, direction) => {
    const list = [...contacts[setor][periodo]];
    const newIndex = index + direction;

    if (newIndex < 0 || newIndex >= list.length) return;

    [list[index], list[newIndex]] = [list[newIndex], list[index]];
    const updated = { ...contacts };
    updated[setor][periodo] = list;
    setContacts(updated);

    // Salvar no backend
    axios.post(`${API_URL}/reorder`, updated, {
      headers: { Authorization: token }
    }).catch(() => setError("Erro ao reordenar contatos."));
  };

  const setores = Object.keys(contacts);
  const periodosDisponiveis = [...new Set(setores.flatMap(s => Object.keys(contacts[s] || {})))];

  return (
    <Container className="mt-4">
      <h2 className="text-center text-primary">Gerenciamento de Escalation</h2>




      {error && <Alert variant="danger" onClose={() => setError("")} dismissible>{error}</Alert>}

      <Row className="mb-4">
        <Col md={3}>
          <Form.Select value={newSetor} onChange={(e) => setNewSetor(e.target.value)}>
            <option value="">Selecione o Setor</option>
            {setores.map((s, idx) => <option key={idx} value={s}>{s}</option>)}
          </Form.Select>
        </Col>
        <Col md={2}>
          <Form.Select value={newPeriodo} onChange={(e) => setNewPeriodo(e.target.value)}>
            <option value="">Período</option>
            {periodosDisponiveis.map((p, idx) => <option key={idx} value={p}>{p}</option>)}
          </Form.Select>
        </Col>
        <Col md={3}><Form.Control type="text" placeholder="Nome" value={newName} onChange={(e) => setNewName(e.target.value)} /></Col>
        <Col md={2}><Form.Control type="text" placeholder="Telefone" value={newPhone} onChange={(e) => setNewPhone(e.target.value)} /></Col>
        <Col md={2}><Button variant="success" onClick={handleAddContact}><FaPlus /> Adicionar</Button></Col>
      </Row>

      {loading ? (
  <div className="text-center my-4">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Carregando...</span>
    </div>
  </div>
) : (
      <Accordion>
        {Object.entries(contacts).map(([setor, periodos], i) => (
          <Accordion.Item eventKey={i.toString()} key={setor}>
            <Accordion.Header>
              <strong>{setor === "default" ? "Setor Fallback" : setor}</strong>
            </Accordion.Header>
            <Accordion.Body>
              {Object.entries(periodos).map(([periodo, lista]) => (
                <div key={`${setor}-${periodo}`} className="mb-4">
                  <h5><Badge bg="secondary">{periodo === "default" ? "Fallback" : periodo}</Badge></h5>
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th style={{ width: "60%" }}>Nome</th>
                        <th style={{ width: "20%" }}>Telefone</th>
                        <th style={{ width: "15%" }}>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lista.map((contato, index) => {
                        const isEditing = editMode &&
                          editMode.setor === setor &&
                          editMode.periodo === periodo &&
                          editMode.old_name === contato.name;

                        return (
                          <tr key={index}>
                            <td>
                              {isEditing
                                ? <Form.Control size="sm" value={editData.name} onChange={(e) => setEditData({ ...editData, name: e.target.value })} />
                                : contato.name}
                            </td>
                            <td>
                              {isEditing
                                ? <Form.Control size="sm" value={editData.phone} onChange={(e) => setEditData({ ...editData, phone: e.target.value })} />
                                : <><FaPhone className="text-primary me-1" /> {contato.phone}</>}
                            </td>
                            <td>
                              {isEditing ? (
                                <>
                                  <Button size="sm" variant="success" onClick={handleSaveEdit} className="me-2"><FaCheck /></Button>
                                  <Button size="sm" variant="secondary" onClick={handleCancelEdit}><FaTimes /></Button>
                                </>
                              ) : (
                                <>
                                  <Button size="sm"  variant="light" className="me-2"
                                    onClick={() => handleEdit(setor, periodo, contato.name, contato.phone)}>
                                    <FaEdit />
                                  </Button>
                                  <Button size="sm"  variant="light" className="me-2"
                                    onClick={() => handleDelete(setor, periodo, contato.name)}>
                                    <FaTrash />
                                  </Button>
                                  <Button size="sm" variant="light" className="me-1"
                                    onClick={() => moveContact(setor, periodo, index, -1)}
                                    disabled={index === 0}>
                                    <FaArrowUp />
                                  </Button>
                                  <Button size="sm" variant="light"
                                    onClick={() => moveContact(setor, periodo, index, 1)}
                                    disabled={index === lista.length - 1}>
                                    <FaArrowDown />
                                  </Button>
                                </>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                  
                </div>
                
              ))}
                    <small className="text-muted d-block text-end mt-2">
        * Períodos automáticos: <strong>Comercial</strong> (07h–17h), <strong>Noite</strong> (17h–22h), <strong>Madrugada</strong> (22h–07h).
      </small>
            </Accordion.Body>
          </Accordion.Item>
          
        ))}
      </Accordion>
      
    )}
    </Container>
  );
};

export default Escalation;
